import React from "react";
import { BsGithub } from "react-icons/bs";
import { FaGlobe } from "react-icons/fa";

const ProjectsCard = ({ title, des, src, url, git }) => {
  return (
    <div className="w-full p-4 xl:px-6 h-auto xl:py-6 rounded-lg shadow-shadowOne dark:shadow-[#1c1e22] shadow-gray-200 flex flex-col dark:bg-black bg-white bg-opacity-50 dark:bg-opacity-25 transition-colors duration-1000 flex-1 md:flex-[25%] lg:flex-[30%] md:max-w-[30%] ">
      <div className="w-full h-[80%] overflow-hidden rounded-lg shadow-lg">
        <img
          className="w-full h-48 object-cover group-hover:scale-110 duration-300 cursor-pointer"
          src={src}
          alt="src"
        />
      </div>
      <div className="w-full mt-5 flex flex-col  gap-6">
        <div>
          <div className="flex items-center justify-between">
            <h3 className="text-lg uppercase text-blue-600 dark:text-designColor font-medium">
              {title}
            </h3>
            <div className="flex gap-2">
              {git ? (
                <a href={git} target="_blank" rel="noreferrer">
                  <span className="text-lg w-10 h-10 rounded-full dark:bg-black bg-blue-100 inline-flex justify-center items-center dark:text-gray-400 text-gray-600 dark:hover:text-designColor hover:text-blue-600 duration-300 cursor-pointer">
                    <BsGithub />
                  </span>
                </a>
              ) : (
                ""
              )}
              {url ? (
                <a href={url} target="_blank" rel="noreferrer">
                  <span className="text-lg w-10 h-10 rounded-full dark:bg-black bg-blue-100 inline-flex justify-center items-center dark:text-gray-300 text-gray-600 dark:hover:text-designColor hover:text-blue-600 duration-300 cursor-pointer">
                    <FaGlobe />
                  </span>
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
          <p className="text-sm tracking-wide mt-3 dark:text-gray-400 hover:text-black dark:hover:text-gray-100 text-gray-500  duration-300">
            {des}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProjectsCard;
